import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["settlementCurrencyCode", "settlementCurrencyValue"];
import { memo } from 'react';
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import { useFormattedCurrencyDisplay } from '../v2/hooks/useFormattedCurrencyDisplay';
import { useAdditionalPropertyValues } from '../v2/hooks/useAdditionalPropertyValues';
import { usePropertyDefinition } from '../v2/hooks/usePropertyDefinition';
import { usePropertyValue } from '../v2/hooks/usePropertyValue';
import FormattedPropertyCurrencyV2 from '../v2/components/FormattedPropertyCurrencyV2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FormattedCurrencyConversionProperty = _ref => {
  let {
      settlementCurrencyCode,
      settlementCurrencyValue
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    className,
    currencyProps = {}
  } = props;
  const formattedCurrencyDisplay = useFormattedCurrencyDisplay();
  const formattedSettlementCurrencyDisplay = useFormattedCurrencyDisplay({
    defaultValue: settlementCurrencyValue,
    defaultCurrencyCode: settlementCurrencyCode
  });
  return /*#__PURE__*/_jsxs("span", {
    className: className,
    "data-test-id": "currency-conversion-property",
    children: [/*#__PURE__*/_jsx(FormattedCurrency, Object.assign({}, currencyProps, {
      value: formattedCurrencyDisplay.currencyValue,
      currencyCode: formattedCurrencyDisplay.currencyCode
    })), ' ', "(", /*#__PURE__*/_jsx(FormattedCurrency, Object.assign({}, currencyProps, {
      value: formattedSettlementCurrencyDisplay.currencyValue,
      currencyCode: formattedSettlementCurrencyDisplay.currencyCode
    })), ")"]
  });
};
const FormattedSettlementCurrency = props => {
  const propertyValue = usePropertyValue();
  const propertyDefinition = usePropertyDefinition();
  const {
    data: settlementCurrencyPropertyValues
  } = useAdditionalPropertyValues({
    exchangeRate: 'hs_presentment_to_settlement_currency_exchange_rate',
    settlementCurrencyValue: `${propertyDefinition.name}_in_settlement_currency`,
    settlementCurrencyCode: 'hs_settlement_currency_code'
  });
  if (propertyValue && settlementCurrencyPropertyValues !== null && settlementCurrencyPropertyValues !== void 0 && settlementCurrencyPropertyValues.exchangeRate && settlementCurrencyPropertyValues !== null && settlementCurrencyPropertyValues !== void 0 && settlementCurrencyPropertyValues.settlementCurrencyValue && settlementCurrencyPropertyValues !== null && settlementCurrencyPropertyValues !== void 0 && settlementCurrencyPropertyValues.settlementCurrencyCode) {
    // Has all the necessary values to display the settlement currency in brackets
    return /*#__PURE__*/_jsx(FormattedCurrencyConversionProperty, Object.assign({}, props, {
      settlementCurrencyValue: settlementCurrencyPropertyValues.settlementCurrencyValue,
      settlementCurrencyCode: settlementCurrencyPropertyValues.settlementCurrencyCode
    }));
  }
  return /*#__PURE__*/_jsx(FormattedPropertyCurrencyV2, Object.assign({}, props));
};
export default /*#__PURE__*/memo(FormattedSettlementCurrency);